// extracted by mini-css-extract-plugin
export default {"successMessage":"documents-download-toaster_successMessage__6Z7Hz","viewFileText":"documents-download-toaster_viewFileText__Ia0wu"};